(ns ycweb.app.website.myaccount.aftersales.view
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc case-item-line < rum/reactive [app-atom return-case-item]
  (let [{:item-line/keys [variation product]
         :return-case-item/keys [reason-text]} return-case-item]
    (list
      [:tr.yc-tr
       [:td
        {:class (u/bem :yc-td [:yc-td--product-image])}
        (web-common/lazy-image app-atom
          (:doc/public-id (:ent/image variation))
          {:class ["yc-td__image"]}
          {:w 100 :h 100})]
       [:td
        {:class (u/bem :yc-td [:product-text])}
        [:div.yc-td__product-name
         (:ent/display-name product)]]
       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span.yc-td__faux-table {:data-th "Quantity"}
         [:span.yc-td__faux-td
          (:item-line/qty return-case-item)]]]
       [:td.yc-td
        [:span.yc-td__faux-table {:data-th "Type"}
         [:span.yc-td__faux-td
          (:return-case-item/type return-case-item)]]]
       [:td.yc-td
        [:span.yc-td__faux-table {:data-th "Reason"}
         [:span.yc-td__faux-td
          reason-text]]]])))

(rum/defc viewreturn < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        return-case-atom (rum/cursor-in action-atom [:return-case])

        {:return-case/keys [status date-added return-order items] :as return-case}
        (rum/react return-case-atom)]
    [:div.dashboard
     (headings/heading (str "Return Case " (:ent/display-name return-case))
       {:type :h2 :size :medium})
     (feedback/feedback
       (cond
         (contains?
           #{"Repairs Complete" "Resolved"}
           status)
         :success

         (= status "Cancelled")
         :error

         (contains?
           #{"Pending" "Processing" "Requiring Credit"}
           status)
         :warning

         :else
         :info)

       (str status)
       [:span
        (str "Date requested: " (ud/date-format (ud/coerce-date date-added) "dd MMM YYYY"))

        (when (u/presence (:ent/uuid return-order))
          [:span " - "
               ;;todo - replace link with uuid link
           [:a.text-link (urlstate/href-props app-atom "myaccount" "trackview" {:uuid (:ent/uuid return-order)})
            (str "View resolution order " (:ent/display-name return-order))]])])

     [:table.yc-table.yc-table--order-view
      [:caption.yc-table-caption.hidden-from-view (str "Summary of your return order " (:ent/display-name return-case))]
      [:colgroup
       [:col {:width "100"}]
       [:col {:width "200"}]
       [:col]
       [:col {:width "160"}]
       [:col]]
      [:thead.yc-thead
       [:tr.yc-tr
        [:th.yc-th {:scope "col"} "Item"]
        [:th.yc-th {:scope "col"} "Description"]
        [:th.yc-th.yc-th--centered {:scope "col"} "Qty"]
        [:th.yc-th {:scope "col"} "Return Type"]
        [:th.yc-th {:scope "col"} "Return Reason"]]]
      [:tbody.yc-tbody
       (concat
         (map (partial case-item-line app-atom) items))]]
     (toaster/loading-overlay app-atom :web.myaccount/viewreturn)]))

(defmethod flow/render-screen :web.myaccount/viewreturn [app-atom _]
  (awm.common/screen-wrapper app-atom
    (viewreturn app-atom)))

(defmethod t/transition-open :web.myaccount/viewreturn [app-atom _ params]
  (toaster/open-overlay app-atom :web.myaccount/viewreturn)
  (comms/ajax-get :web.myaccount/viewreturn (select-keys params [:uuid])))

(defmethod comms/receive :web.myaccount/viewreturn [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/viewreturn)
  (swap! (cmn/action-cursor app-atom) assoc :return-case (:return-case e)))
